const defaultState = {
  difficultyLevels: [],
};

const getters = {
  all: (state) => state.difficultyLevels,
};

const mutations = {
  set: function(state, levels) {
    state.difficultyLevels = levels;
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
};

